import React from 'react';
import './ShopAllPage.css';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ProductHub from '../../components/ProductHub/ProductHub';
import Banner from '../../components/Banner/Banner';
import ShopAllBanner from '../../assets/banner1.jpg'

const ShopAllPage = () => {
  return (
    <div className='page__wrapper'>
        <Navbar />
        <div className='auth__container'>
            <div className='shopAll__container'>

                <Banner imgSrc={ShopAllBanner} imgAlt={"Shop All Items from Alex Menswear"} />
                <ProductHub />
                <ProductHub />
            </div>
        
        </div>
        <Footer />
    </div>
  )
}

export default ShopAllPage
